import { Component, OnInit} from '@angular/core';
import { ProvidersService} from '../../services/providers.service';
import {LocalDataSource} from 'ng2-smart-table';
import { UpdateModalComponent} from '../../modals/update-modal/update-modal.component';
import { AlertaService} from '../../../../../shared/services/alerta.service';
import { ModalService} from 'ngx-dynamic-modal';
import { ActionButtonsComponent} from '../../../../../shared/components/smart-table/action-buttons/action-buttons.component';
import {id} from '@swimlane/ngx-datatable/release/utils';
import {Router} from '@angular/router';


@Component({
  selector: 'app-list-providers',
  templateUrl: './list-providers.component.html',
  styleUrls: ['./list-providers.component.scss']
})
export class ListProvidersComponent implements OnInit {
    settings: Object;
    providers: Array<Object> = [];
    enabled: boolean;
    constructor(private ProviderService: ProvidersService, private modalService: ModalService, private alerta:AlertaService, private router: Router) {

        //this.providers = new LocalDataSource();
        /*this.settings = {
            columns:
                {pk: {title: '#',
                    width: '5%',},
                name: {title: 'Name'},
                label: {title: 'Label'},
                comments: {title: 'Comment'},
                created_at: {title: 'Created at'},
                Actions: {
                    filter: false,
                    width:'10%',
                    title:'Actions ',
                    type: 'custom',
                    renderComponent: ActionButtonsComponent,
                    onComponentInitFunction:(instance: any) => {
                        instance.action.subscribe(data => {
                            if(data.action ==='onDelete'){
                                this.deleteProvider(data.element);
                            }else{
                                this.openModal(data.element);
                            }
                        });
                    }
                    }
                },
            attr: {
                class: 'table table-bordered'
                  },
            actions: {
               add: false,
                delete: false,
                edit: false
                     },
            mode: 'external',
            pager:{
                display:true,
                perPage:10
            }
        };*/
  }

  ngOnInit() {
        this.enabled = true;
        this.ProviderService.getServiceProviders()
            .subscribe(result => {
                this.providers = result
            }, error => {
                console.log(error);
            }, () => {
                this.enabled = false;
            });
  }

    goToCallerIdConfig(pkProvider: number, providerName: string): void {
        this.router.navigateByUrl('phone/config/providers/' + pkProvider + '/caller-ids-configs?provider_name=' + providerName);
    }

  openModal(data= null) {
        this.modalService.addDynamicComponent(UpdateModalComponent, {data}, (res) => {
            if (!res.edit) {
                this.providers.push(res.element);
            } else {
                const idx = this.providers.findIndex( (o) => { return o['pk'] == res.element['pk']; });
                this.providers.splice(idx, 1);
                this.providers.push(res.element);
                }
        })
  }

  deleteProvider(provider) {
        this.alerta.addAlert('confirm','Do you want to Delete provider '+ provider.name+ '?')
      .then((result)=>{
          if(result.value){
              this.enabled=true;
              this.ProviderService.removeServiceProvider(provider.pk)
                  .subscribe( result => {
                  }, error => {
                      console.log(error);
                      this.enabled=false;
                  }, () => {
                     this.alerta.addAlert('success','Provider Deleted Succesfully!!');
                      let idx = this.providers.findIndex( (o) => { return o['pk'] == provider['pk'] });
                      this.providers.splice(idx, 1);
                     this.enabled=false
                  })
          }
      })
  }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/providers/components/list-providers/list-providers.component.ts